<template>
  <div class="inline-flex items-center">
    <Check
      v-if="status === 'SEND' || status === 'SENT'"
      :size="16"
      :stroke-width="2.5"
      class="text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]"
    />
    <CheckCheck
      v-else-if="status === 'DELIVERED'"
      :size="16"
      :stroke-width="2.5"
      class="text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]"
    />
    <CheckCheck
      v-else-if="status === 'READ'"
      :size="16"
      :stroke-width="2.5"
      class="text-blue-500 dark:text-blue-400"
    />
    <X
      v-else-if="status === 'FAILED'"
      :size="16"
      :stroke-width="2.5"
      class="text-red-500 dark:text-red-400"
    />
    <Clock
      v-else
      :size="16"
      :stroke-width="2.5"
      class="text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]"
    />
  </div>
</template>

<script setup lang="ts">
import { Check, CheckCheck, X, Clock } from 'lucide-vue-next'
import type { MessageStatus } from '../../types/enums'

interface Props {
  status?:
    | MessageStatus
    | 'SEND'
    | 'SENT'
    | 'DELIVERED'
    | 'READ'
    | 'FAILED'
    | 'PENDING'
    | 'ENQUEUED'
  sent?: boolean
}

withDefaults(defineProps<Props>(), {
  status: 'PENDING',
  sent: false,
})
</script>
